/**
 * Thinking Engine — reasoning helpers.
 *
 * Small, pure utilities the reasoning steps use to build decisions and their
 * WHY sentences deterministically from the inputs. No AI, no randomness.
 */

/** A single reasoning decision: what was chosen, WHY, and its provenance. */
export const decision = (choice, why, basis = []) => ({ choice, why, basis });

export const list = (v) => (Array.isArray(v) ? v.filter((x) => typeof x === 'string' && x) : []);

/** "geometric-sans" → "geometric sans" for readable WHY sentences. */
export const humanize = (tag) => (typeof tag === 'string' ? tag.replace(/-/g, ' ') : '');

/** Join the first n reasons from a research list into a readable clause. */
export const firstReasons = (arr, n = 2) => {
  const items = list(arr).slice(0, n).map(humanize);
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
};

/** Deduped union of string lists, order-preserving. */
export const union = (...arrays) => {
  const seen = new Set();
  const out = [];
  arrays.forEach((a) => list(a).forEach((x) => { if (!seen.has(x)) { seen.add(x); out.push(x); } }));
  return out;
};

/** A WHY suffix noting a memory-flagged variation axis (or '' when none). */
export const variationNote = (dimension, variationAxes) =>
  list(variationAxes).includes(dimension)
    ? ` Memory flags ${dimension} as over-used across recent designs, so this choice deliberately diverges.`
    : '';
